<!--Header Start-->
<header>
  <div class="row header_cls" [ngClass]="{'sticky' : isSticky}">
    <div class="col-md-4">
      <div class="logo_cls" routerLink="/home">
        <img src="assets/images/logo.png">
        <p> प्रशिक्षण महानिदेशालय <br>
          <b> Directorate General of Training </b>
        </p>
      </div>
    </div>

    <div class="col-md-8">
      <ul class="menu_cls cus" [class]="menu_show_hide" (click)="tests()">
        <!-- <li routerLink="/home" routerLinkActive="active">Home</li> -->
        <li routerLink="/aboutcbt" routerLinkActive="active">About CBT </li>
        <!-- <li routerLink="/download" routerLinkActive="active">Downloads </li> -->
        <!-- <li routerLink="/examfee" routerLinkActive="active">Exam Fees </li> -->
        <li routerLink="/Instructions" routerLinkActive="active">Instructions </li>
        <li routerLink="/exam" routerLinkActive="active">Exams </li>
        <li routerLink="/download" routerLinkActive="active">Downloads </li>

        <li routerLink="/faq" routerLinkActive="active">FAQ</li>
        <li routerLink="/crs" routerLinkActive="active">Grievance</li>
        <!-- <li routerLink="/grs" routerLinkActive="active">GRS New</li> -->
        <!-- <li> <a target="_blank" href="https://nimionlineadmission.in/aitt/"> Login </a></li> -->
        <li routerLink="/mobileapp" routerLinkActive="active"> Mobile App </li>
      </ul>
    </div>

    <div class="bar_mob" [class]="open" (click)="toggle_show()">
      <i class="fa fa-bars" aria-hidden="true"></i>
    </div>
    <div class="bar_mob" [class]="close" (click)="toggle_hide()">
      <i class="fa fa-times" aria-hidden="true"></i>
    </div>
  </div>
</header>
<router-outlet></router-outlet>


<app-footer *ngIf="footer_bool"></app-footer>
<div class="footer_btm">
  <div class="container-fluid">
    <div class="row">


      <div class="col-md-12">
        <p class="footer_btm_rt">Powerd By <span><img src="assets/images/NIMI logo INV.png" width="50px" /></span> </p>
      </div>
    </div>
  </div>
</div>

<!--footer End-->